<template>
  <div class="kt-portlet kt-portlet--height-fluid">
    <div class="kt-portlet__body">
      <v-card>
        <v-tabs
          next-icon="fad fa-arrow-square-right"
          prev-icon="fad fa-arrow-square-left"
          show-arrows
        >
          <template v-for="(internetShop, index) in internetShops">
            <v-tab>{{ dealerName(internetShop, index) }}</v-tab>
            <v-tab-item>
              <true-car
                v-if="internetShop.truecar_fields"
                :internetShop="internetShop"
              />
            </v-tab-item>
          </template>
        </v-tabs>
      </v-card>
    </div>
  </div>
</template>
<script>
import TrueCar from '../ShopPost/TrueCar.vue';

export default {
  name: 'TrueCarQuestions',

  components: {
    TrueCar,
  },

  props: {
    internetShops: {
      required: true,
      type: Array,
    },
    hideDealerName: {
      default: false,
    },
  },

  methods: {
    dealerName(shop, index) {
      if (!shop.is_dealer) {
        return this.hideDealerName ? `Local Competitor` : shop.competitor.name;
      }
      return shop.specific_dealer.name;
    },
  },
};
</script>
